document.addEventListener("DOMContentLoaded", function () {
    const footer = document.querySelector("#shopify-section-footer");
    const footerLastSec = document.querySelector(".footer-last-sec");

    function toggleFooterPadding() {
        if (window.innerWidth <= 768) { // Apply only for mobile devices
            if (footer.getBoundingClientRect().top < window.innerHeight) {
                // Add padding to footer-last-sec when the footer is visible
                if (footerLastSec) {
                    footerLastSec.style.paddingBottom = "80px";
                }
            } else {
                // Reset padding when footer is not visible
                if (footerLastSec) {
                    footerLastSec.style.paddingBottom = "";
                }
            }
        } else {
            // Ensure footer-last-sec resets on desktop
            if (footerLastSec) {
                footerLastSec.style.paddingBottom = "";
            }
        }
    }

    window.addEventListener("scroll", toggleFooterPadding);
});

document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("offerToggle");
    const moreOffers = document.getElementById("moreOffers");

    if (toggle && moreOffers) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const isHidden = moreOffers.classList.toggle("hidden");

            // Add or remove active-border on all .offer-details
            const offerCards = moreOffers.querySelectorAll(".offer-details");
            offerCards.forEach(card => {
                card.classList.toggle("active-border", !isHidden);
            });

            // Ensure the best offer also has a border (if needed)
            // Add or remove active-border on ALL .offer-details globally
            const allCards = document.querySelectorAll(".offer-details");
            allCards.forEach(card => {
                card.classList.toggle("active-border", !isHidden);
            });


            // Toggle button text
            const textElement = toggle.querySelector(".offer-text");
            if (textElement) {
                textElement.textContent = isHidden ? "View All" : "View Less";
            } else {
                toggle.textContent = isHidden ? "View All" : "View Less";
            }
        });
    }

    // ✅ Clipboard logic
    document.querySelectorAll(".copy-icon").forEach(el => {
        el.addEventListener("click", function () {
            const code = el.dataset.code;
            navigator.clipboard.writeText(code).then(() => {
                const clipboard = el.querySelector(".clipboard-icon");
                const check = el.querySelector(".check-icon");

                if (clipboard && check) {
                    clipboard.style.display = "none";
                    check.style.display = "inline";

                    setTimeout(() => {
                        check.style.display = "none";
                        clipboard.style.display = "inline";
                    }, 1200);
                }
            }).catch(err => {
                console.error("Copy failed:", err);
            });
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("mo-offerModal");
    const toggle = document.getElementById("mo-offerToggle");
    const closeBtn = document.getElementById("mo-closeModal");

    if (toggle && modal && closeBtn) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            modal.classList.remove("mo-hidden");
        });

        closeBtn.addEventListener("click", function () {
            modal.classList.add("mo-hidden");
        });

        window.addEventListener("click", function (e) {
            if (e.target === modal) {
                modal.classList.add("mo-hidden");
            }
        });
    }

    // ✅ Clipboard copy functionality (safe addition)
    const copyIcons = document.querySelectorAll(".mo-copy-icon");
    copyIcons.forEach(icon => {
        icon.addEventListener("click", function () {
            const code = icon.dataset.code;
            if (!code) return;

            navigator.clipboard.writeText(code).then(() => {
                const clipboardIcon = icon.querySelector(".mo-clipboard-icon");
                const checkIcon = icon.querySelector(".mo-check-icon");

                if (clipboardIcon && checkIcon) {
                    clipboardIcon.style.display = "none";
                    checkIcon.style.display = "inline";

                    setTimeout(() => {
                        checkIcon.style.display = "none";
                        clipboardIcon.style.display = "inline";
                    }, 1200);
                }
            }).catch(err => {
                console.error("Clipboard copy failed:", err);
            });
        });
    });
});


let viewMore_div = document.querySelectorAll(".offers--above2");
let viewMore_btn = document.querySelector(".view-more_button");
if (viewMore_btn != null) {
    viewMore_btn.addEventListener("click", function () {
        viewMore_div.forEach(element => {
            element.classList.toggle("offers_view-more");
        });
        if (viewMore_btn.innerHTML == "View less")
            viewMore_btn.innerHTML = "View more offers";
        else
            viewMore_btn.innerHTML = "View less";
    })
}
let accordian_btn = document.querySelectorAll(".js-accordion-header");
accordian_btn.forEach((btn) => {
    btn.addEventListener("click", function () {
        let arrow = this.querySelector(".accordian-arrow");
        arrow.classList.toggle("rotate-180");
        console.log("click");
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const bar = document.querySelector('.add-cart-quantity_container.df');

    function toggleStickyBar() {
        const isMobile = window.innerWidth < 768;

        if (!isMobile) {
            bar.classList.remove('add-cart-visible');
            return;
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / totalHeight) * 100;

        if (scrollPercent >= 5) {
            bar.classList.add('add-cart-visible');
        } else {
            bar.classList.remove('add-cart-visible');
        }
    }

    window.addEventListener('scroll', toggleStickyBar);
    window.addEventListener('resize', toggleStickyBar);
});

function initStickyAddToCartBar() {
    updateRadioButtonAttributes();
initQuantityValidation();
    const bar = document.querySelector('.add-cart-quantity_container.df');
    if (!bar) return;

    function toggleStickyBar() {
        const isMobile = window.innerWidth < 768;

        if (!isMobile) {
            bar.classList.remove('add-cart-visible');
            return;
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / totalHeight) * 100;

        if (scrollPercent >= 5) {
            bar.classList.add('add-cart-visible');
        } else {
            bar.classList.remove('add-cart-visible');
        }
    }

    window.addEventListener('scroll', toggleStickyBar);
    window.addEventListener('resize', toggleStickyBar);
    toggleStickyBar(); // Call once on init to set initial state
    updateRadioButtonAttributes(); // ✅ Inventory rebind
initQuantityValidation(); // ✅ Quantity logic rebind
}

document.addEventListener("DOMContentLoaded", initStickyAddToCartBar);


function updateRadioButtonAttributes() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            document.querySelectorAll('.swatches__form--input').forEach(radio => {
                const variantId = radio.getAttribute('data-variant-id');
                if (variantId) {
                    let cartQuantity = 0;

                    // Find the cart quantity for this variant
                    cart.items.forEach(item => {
                        if (item.variant_id == variantId) {
                            cartQuantity = item.quantity;
                        }
                    });

                    // Get the inventory quantity from the data attribute
                    const inventoryQuantity = parseInt(radio.getAttribute('data-inventory-quantity')) || 0;

                    // Calculate the total available quantity
                    const totalAvailableQty = inventoryQuantity - cartQuantity;

                    // Update attributes
                    radio.setAttribute('data-cart-quantity', cartQuantity);
                    radio.setAttribute('data-total-available-qty', totalAvailableQty);
                }
            });
        })
        .catch(error => console.error('Error updating radio button attributes:', error));
}

// Attach to Add to Cart button click
document.addEventListener("DOMContentLoaded", () => {
    const addToCartBtn = document.getElementById("addToCart");
    if (addToCartBtn) {
        addToCartBtn.addEventListener("click", () => {
            updateRadioButtonAttributes();
        });
    }
});


// function initQuantityValidation() {
//   const quantityInput = document.querySelector(".js-qty-input");
//   const decreaseButton = document.querySelector(".quantity-control-down");
//   const increaseButton = document.querySelector(".quantity-control-up");
//   const addToCartButton = document.getElementById("addToCart");
//   const errorPopup = document.getElementById("quantityErrorMessage");
//   const closeErrorMessage = document.getElementById("closeErrorMessage");

//   if (!quantityInput || !addToCartButton || !increaseButton || !decreaseButton) return;

//   function updateDecreaseButtonState() {
//     const value = parseInt(quantityInput.value, 10);
//     if (isNaN(value) || value <= 1) {
//       decreaseButton.disabled = true;
//       decreaseButton.classList.add("disabled");
//     } else {
//       decreaseButton.disabled = false;
//       decreaseButton.classList.remove("disabled");
//     }
//   }

//   function getCartData() {
//     try {
//       return JSON.parse(localStorage.getItem("cart")) || [];
//     } catch {
//       return [];
//     }
//   }

//   function getCartQuantity(variantId) {
//     const cartItems = getCartData();
//     const cartItem = cartItems.find(item => item.variantId == variantId);
//     return cartItem ? cartItem.quantity : 0;
//   }

//   function checkInventory() {
//     const selectedVariant = document.querySelector('input[name="size"]:checked');
//     if (!selectedVariant) return;

//     const maxInventory = parseInt(selectedVariant.getAttribute("data-total-available-qty"), 10);
//     const variantId = selectedVariant.getAttribute("data-variant-id");
//     const cartQuantity = getCartQuantity(variantId);
//     const currentValue = parseInt(quantityInput.value, 10);

//     if (isNaN(currentValue) || currentValue < 0 || currentValue + cartQuantity > maxInventory) {
//       showErrorPopup();
//       addToCartButton.classList.remove("clearfix", "AddtoCart", "js-ajax-submit");
//     } else {
//       hideErrorPopup();
//       addToCartButton.classList.add("clearfix", "AddtoCart", "js-ajax-submit");
//     }

//     updateDecreaseButtonState();
//   }

//   function showErrorPopup() {
//     errorPopup.style.display = "flex";
//     errorPopup.style.bottom = "20px";
//     setTimeout(hideErrorPopup, 3000);
//   }

//   function hideErrorPopup() {
//     errorPopup.style.bottom = "-100px";
//     setTimeout(() => {
//       errorPopup.style.display = "none";
//     }, 500);
//   }

//   increaseButton.addEventListener("click", () => setTimeout(checkInventory, 50));
//   decreaseButton.addEventListener("click", () => setTimeout(checkInventory, 50));
//   quantityInput.addEventListener("input", () => {
//   // ✅ Allow user to clear input while typing
//   quantityInput.value = quantityInput.value.replace(/[^0-9]/g, "");

//   // ✅ No forced reset while typing — allow blank
//   checkInventory();
//   updateDecreaseButtonState();
// });

// // ✅ On blur (focus out), reset to 1 if empty or 0
// quantityInput.addEventListener("blur", () => {
//   if (quantityInput.value === "" || quantityInput.value === "0") {
//     quantityInput.value = 1;
//     updateDecreaseButtonState();
//     checkInventory();
//   }
// });


//   if (closeErrorMessage) {
//     closeErrorMessage.addEventListener("click", (e) => {
//       e.preventDefault();
//       hideErrorPopup();
//     });
//   }

//   // Reset quantity on ATC click
//   if (addToCartButton) {
//     addToCartButton.addEventListener("click", () => {
//       setTimeout(() => {
//         quantityInput.value = 1;
//         updateDecreaseButtonState();
//         addToCartButton.classList.add("clearfix", "AddtoCart", "js-ajax-submit");
//       }, 500);
//     });
//   }

//   updateDecreaseButtonState();
//   checkInventory();
// }

function initQuantityValidation() {
  const quantityInput = document.querySelector(".js-qty-input");
  const decreaseButton = document.querySelector(".quantity-control-down");
  const increaseButton = document.querySelector(".quantity-control-up");
  const addToCartButton = document.getElementById("addToCart");
  const errorPopup = document.getElementById("quantityErrorMessage");
  const closeErrorMessage = document.getElementById("closeErrorMessage");

  if (!quantityInput || !addToCartButton || !increaseButton || !decreaseButton) return;

  function updateDecreaseButtonState() {
    const value = parseInt(quantityInput.value, 10);
    if (isNaN(value) || value <= 1) {
      decreaseButton.disabled = true;
      decreaseButton.classList.add("disabled");
    } else {
      decreaseButton.disabled = false;
      decreaseButton.classList.remove("disabled");
    }
  }

  function getCartData() {
    try {
      return JSON.parse(localStorage.getItem("cart")) || [];
    } catch {
      return [];
    }
  }

  function getCartQuantity(variantId) {
    const cartItems = getCartData();
    const cartItem = cartItems.find(item => item.variantId == variantId);
    return cartItem ? cartItem.quantity : 0;
  }

  function checkInventory() {
    const selectedVariant = document.querySelector('input[name="size"]:checked');
    if (!selectedVariant) return;

    const maxInventory = parseInt(selectedVariant.getAttribute("data-total-available-qty"), 10);
    const variantId = selectedVariant.getAttribute("data-variant-id");
    const cartQuantity = getCartQuantity(variantId);
    const currentValue = parseInt(quantityInput.value, 10);

    // ❌ If field is empty or not a number, skip validation until blur
    if (quantityInput.value === "" || isNaN(currentValue)) {
      addToCartButton.disabled = true;
      addToCartButton.classList.remove("clearfix", "AddtoCart", "js-ajax-submit");
      return;
    }

    if (currentValue + cartQuantity > maxInventory || currentValue <= 0) {
      showErrorPopup();
      addToCartButton.disabled = true;
      addToCartButton.classList.remove("clearfix", "AddtoCart", "js-ajax-submit");
    } else {
      hideErrorPopup();
      addToCartButton.disabled = false;
      addToCartButton.classList.add("clearfix", "AddtoCart", "js-ajax-submit");
    }

    updateDecreaseButtonState();
  }

  function showErrorPopup() {
    errorPopup.style.display = "flex";
    errorPopup.style.bottom = "20px";
    setTimeout(hideErrorPopup, 3000);
  }

  function hideErrorPopup() {
    errorPopup.style.bottom = "-100px";
    setTimeout(() => {
      errorPopup.style.display = "none";
    }, 500);
  }

  // 🛠 INPUT VALIDATION (Typing)
  quantityInput.addEventListener("input", () => {
    quantityInput.value = quantityInput.value.replace(/[^0-9]/g, "");

    // ✅ Remove all zeros (e.g. 0 or 00) while typing
    if (/^0+$/.test(quantityInput.value)) {
      quantityInput.value = "";
    }

    checkInventory();
    updateDecreaseButtonState();
  });

  // 🛠 BLUR VALIDATION
  quantityInput.addEventListener("blur", () => {
    if (quantityInput.value === "" || quantityInput.value === "0") {
      quantityInput.value = 1;
    } else {
      // ✅ Remove leading zeros like 01 → 1
      quantityInput.value = parseInt(quantityInput.value, 10);
    }
    updateDecreaseButtonState();
    checkInventory();
  });

  // 🛠 BUTTON CLICK VALIDATION
  increaseButton.addEventListener("click", () => setTimeout(checkInventory, 50));
  decreaseButton.addEventListener("click", () => setTimeout(checkInventory, 50));

  if (closeErrorMessage) {
    closeErrorMessage.addEventListener("click", (e) => {
      e.preventDefault();
      hideErrorPopup();
    });
  }

  // 🛠 ATC CLICK FINAL CHECK
  if (addToCartButton) {
    addToCartButton.addEventListener("click", (e) => {
      const qty = parseInt(quantityInput.value, 10);
      if (isNaN(qty) || qty <= 0) {
        e.preventDefault();
        showErrorPopup();
        return;
      }

      setTimeout(() => {
        quantityInput.value = 1;
        updateDecreaseButtonState();
        addToCartButton.classList.add("clearfix", "AddtoCart", "js-ajax-submit");
      }, 500);
    }); 
  }

  updateDecreaseButtonState();
  checkInventory();
}


document.addEventListener("DOMContentLoaded", () => {
  const atcContainer = document.querySelector(".custom-atc-container");
  const addToCartBtn = document.getElementById("addToCart");
  const errorPopup = document.getElementById("quantityErrorMessage");

  if (!atcContainer || !addToCartBtn) return;

  atcContainer.addEventListener("click", function (event) {
    const selectedVariant = document.querySelector('input.swatches__form--input:checked');
    if (!selectedVariant) return;

    const totalQty = parseInt(selectedVariant.getAttribute("data-total-available-qty"), 10);
    if (totalQty === 0) {
      event.preventDefault();
      addToCartBtn.disabled = true;
      addToCartBtn.classList.remove("clearfix", "AddtoCart", "js-ajax-submit");

      if (errorPopup) {
        errorPopup.style.display = "flex";
        errorPopup.style.bottom = "20px";
        setTimeout(() => {
          errorPopup.style.bottom = "-100px";
          setTimeout(() => {
            errorPopup.style.display = "none";
          }, 500);
        }, 3000);
      }
    }
  });
});

function bindVariantChangeQtyReset() {
  const radioButtons = document.querySelectorAll('input.swatches__form--input');

  radioButtons.forEach(radio => {
    radio.addEventListener("change", function () {
      const quantityInput = document.querySelector(".js-qty-input");
      const decreaseButton = document.querySelector(".quantity-control-down");

      if (quantityInput) quantityInput.value = 1;
      if (decreaseButton) {
        decreaseButton.disabled = true;
        decreaseButton.classList.add("disabled");
      }
    });
  });
}


document.addEventListener("DOMContentLoaded", function () {
  bindVariantChangeQtyReset();
});

document.addEventListener("DOMContentLoaded", function () {
  const radioButtons = document.querySelectorAll('input.swatches__form--input');
  const addToCartBtn = document.getElementById("addToCart");

  if (!addToCartBtn) return;

  radioButtons.forEach(radio => {
    radio.addEventListener("change", function () {
      const totalQty = parseInt(this.getAttribute("data-total-available-qty"), 10);

      // ✅ Reset quantity input to 1 on variant change
      const quantityInput = document.querySelector(".js-qty-input");
      const decreaseButton = document.querySelector(".quantity-control-down");

      if (quantityInput) {
        quantityInput.value = 1;
        if (decreaseButton) {
          decreaseButton.disabled = true;
          decreaseButton.classList.add("disabled");
        }
      }

      // Re-enable ATC button based on stock
      if (totalQty > 0) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.add("clearfix", "AddtoCart", "js-ajax-submit");
        addToCartBtn.value = "Add to Cart";
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.remove("clearfix", "AddtoCart", "js-ajax-submit");
        addToCartBtn.value = "Add to Cart";
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", initQuantityValidation);


async function checkServiceability(pincode) {
  const input = document.getElementById("deliveryFullInput");
  const clearBtn = document.getElementById("clearInputBtn");
  const msgBox = document.getElementById("pinMessage");
  const msgIcon = document.getElementById("pinIcon");
  const msgText = document.getElementById("pinText");
  const returnMsg = document.getElementById("returnExchangeMsg");
  const productSection = document.querySelector(".delivery-box");
  const skuId = productSection?.getAttribute("data-sku") || null;

  const successIcon = `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="17.5964" cy="17.2959" r="17.2771" fill="#5891E7" fill-opacity="0.2"/>
<path d="M21.4358 20.9049V11.7769C21.4358 11.2677 21.2335 10.7794 20.8735 10.4194C20.5135 10.0594 20.0252 9.85718 19.5161 9.85718H9.91773C9.4086 9.85718 8.92032 10.0594 8.56031 10.4194C8.2003 10.7794 7.99805 11.2677 7.99805 11.7769V20.4154C7.99805 20.67 8.09917 20.9141 8.27918 21.0941C8.45918 21.2741 8.70332 21.3752 8.95789 21.3752H9.63937C9.82647 20.948 10.134 20.5846 10.5244 20.3294C10.9147 20.0742 11.371 19.9383 11.8374 19.9383C12.3038 19.9383 12.7601 20.0742 13.1504 20.3294C13.5408 20.5846 13.8483 20.948 14.0354 21.3752H21.1574C21.2278 21.2057 21.3206 21.0489 21.4358 20.9049ZM21.4358 20.9049C21.6852 20.5666 22.0195 20.3 22.4049 20.1321C22.7903 19.9642 23.2131 19.9009 23.6307 19.9486C24.0484 19.9963 24.4461 20.1533 24.7837 20.4038C25.1212 20.6543 25.3868 20.9894 25.5535 21.3752H27.1948V18.6013C27.1952 17.9048 27.0061 17.2213 26.6477 16.624L25.4671 14.6564L24.5937 13.207C24.5087 13.0637 24.3879 12.945 24.2432 12.8626C24.0985 12.7801 23.9348 12.7367 23.7682 12.7367H21.4358V20.9049Z" stroke="black" stroke-width="1.13981" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.6368 16.5761H11.8376M16.6368 13.6965H11.8376M14.2372 22.3351C14.2376 22.6921 14.1584 23.0446 14.0053 23.3671C13.8522 23.6896 13.6291 23.9738 13.3522 24.1991C13.0753 24.4244 12.7516 24.5851 12.4048 24.6695C12.0579 24.7539 11.6966 24.7598 11.3472 24.6869C10.9978 24.6139 10.669 24.4639 10.3849 24.2478C10.1008 24.0317 9.86844 23.7549 9.70484 23.4377C9.54124 23.1204 9.45048 22.7706 9.43919 22.4138C9.4279 22.057 9.49635 21.7022 9.63955 21.3752C9.86051 20.8707 10.2483 20.4576 10.7378 20.2052C11.2274 19.9527 11.7888 19.8764 12.328 19.989C12.8671 20.1015 13.3511 20.3961 13.6988 20.8233C14.0464 21.2505 14.2365 21.7843 14.2372 22.3351ZM25.7553 22.3351C25.7557 22.6921 25.6764 23.0446 25.5233 23.3671C25.3702 23.6896 25.1471 23.9738 24.8702 24.1991C24.5934 24.4244 24.2697 24.5851 23.9229 24.6695C23.576 24.7539 23.2147 24.7598 22.8653 24.6869C22.5158 24.6139 22.1871 24.4639 21.903 24.2478C21.6188 24.0317 21.3865 23.7549 21.2229 23.4377C21.0593 23.1204 20.9686 22.7706 20.9573 22.4138C20.946 22.057 21.0144 21.7022 21.1576 21.3752C21.228 21.2057 21.3208 21.0489 21.436 20.9049C21.6854 20.5666 22.0197 20.3 22.4051 20.1321C22.7904 19.9642 23.2133 19.9009 23.6309 19.9486C24.0486 19.9963 24.4462 20.1533 24.7838 20.4038C25.1214 20.6543 25.387 20.9894 25.5537 21.3752C25.6881 21.6776 25.7572 22.0049 25.7553 22.3351Z" stroke="black" stroke-width="1.13981" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
  const errorIcon = `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="17.5" cy="17.5" r="17.5" fill="#FEE2E2"/><path d="M11 11l13 13M24 11L11 24" stroke="#D32F2F" stroke-width="2.5"/></svg>`;
  const loaderIcon = `<div class="spinner"></div>`;

  msgBox.style.display = "flex";
  msgBox.className = "pin-message";
  msgIcon.innerHTML = loaderIcon;
  msgText.textContent = "Checking...";

  const payload = {
    location: pincode,
    items: [{ skuId: skuId, eoisSkuId: null, quantity: 1, sellerId: null }],
    warehouseId: null,
    storePickup: "no",
    deliveryMode: ["standard", "sdd", "ndd"],
  };

  try {
    const res = await fetch("https://apis.arvindfashions.com/api/order/details/check-serviceability", {
      method: "POST",
      headers: { "Content-Type": "application/json", source: "SHOPIFY_USPA" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    const deliveryModes = data?.data?.items?.[0]?.deliverymodes;

    // Clear previous classes so icons/colors update correctly
    msgBox.classList.remove("error", "success");

    if (!deliveryModes || deliveryModes.length === 0) {
      msgBox.classList.add("error");
      msgIcon.innerHTML = errorIcon;
      msgText.textContent = "This pincode is not serviceable.";
      return;
    }

    // ✅ ROBUST FILTER: Ensure we check both Omuni boolean AND string statuses
    const activeModes = deliveryModes.filter(m => 
      m.status === true || 
      m.status === "true" || 
      m.status === "ACTIVE" || 
      m.deliveryDate // If there's a deliveryDate, it's serviceable
    );

    if (activeModes.length === 0) {
      msgBox.classList.add("error");
      msgIcon.innerHTML = errorIcon;
      msgText.textContent = "Delivery services are currently unavailable.";
      return;
    }

    // ✅ Selection logic intact (SDD > NDD > Standard)
    const sdd = activeModes.find(m => m.deliveryType === "sdd");
    const ndd = activeModes.find(m => m.deliveryType === "ndd");
    const std = activeModes.find(m => m.deliveryType === "standard");
    const selected = sdd || ndd || std;

    let estimatedDate;
    if (selected.deliveryDate) {
      const [datePart] = selected.deliveryDate.split(' ');
      const [day, month, year] = datePart.split('-');
      estimatedDate = new Date(`${year}-${month}-${day}`);
    } else {
      const deliveryDays = Math.ceil(selected.deliveryTime / 24) || 3;
      estimatedDate = new Date();
      estimatedDate.setDate(estimatedDate.getDate() + deliveryDays);
    }

    const formattedDate = estimatedDate.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });

    // Save user pincode cookie
    document.cookie = `user_pincode=${pincode}; path=/; max-age=${7 * 24 * 60 * 60}`;

    msgBox.classList.add("success");
    msgIcon.innerHTML = successIcon;

    let deliveryLabel = "Standard Delivery";
    if (selected.deliveryType === "ndd") deliveryLabel = "Next Day Delivery";
    if (selected.deliveryType === "sdd") deliveryLabel = "Same Day Delivery";

    msgText.innerHTML = `${deliveryLabel} - Get it by <span style="color:#13294B; font-weight:700;">${formattedDate}</span>`;
    input.setAttribute("readonly", "true");
    clearBtn.textContent = "Edit";
    if (returnMsg) returnMsg.style.display = "flex";

  } catch (err) {
    console.error("API Error:", err);
    msgBox.classList.add("error");
    msgIcon.innerHTML = errorIcon;
    msgText.textContent = "Please check again after sometime.";
  }
}



function initPincodeChecker() {
  const input = document.getElementById("deliveryFullInput");
  const clearBtn = document.getElementById("clearInputBtn");
  const msgBox = document.getElementById("pinMessage");
  const msgIcon = document.getElementById("pinIcon");
  const msgText = document.getElementById("pinText");
  const expressNote = document.getElementById("expressDeliveryNote");
  const returnMsg = document.getElementById("returnExchangeMsg");
  const productSection = document.querySelector(".delivery-box");
  const skuId = productSection?.getAttribute("data-sku") || null;

  if (!input || !clearBtn || !msgBox || !msgIcon || !msgText || !skuId) return;

  // --- Existing listeners ---
  clearBtn.addEventListener("click", () => {
    const pincode = input.value.trim().replace(/\D/g, "");

    if (clearBtn.textContent === "Edit") {
      input.removeAttribute("readonly");
      clearBtn.textContent = "Check";
      if (expressNote) expressNote.style.display = "block";
      msgBox.style.display = "none";
    } else {
      if (!pincode) {
        msgBox.style.display = "none";
        msgBox.className = "pin-message";
        msgIcon.innerHTML = "";
        msgText.textContent = "";
        if (expressNote) expressNote.style.display = "block";
        return;
      }

      if (pincode.length === 6) {
        if (expressNote) expressNote.style.display = "none";
        checkServiceability(pincode);
      } else {
        msgBox.style.display = "none";
        msgIcon.innerHTML = "";
        msgText.textContent = "";
        msgBox.className = "pin-message";
        if (expressNote) expressNote.style.display = "block";
      }
    }
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") clearBtn.click();
  });

  input.addEventListener("keypress", (e) => {
    if (!/\d/.test(e.key)) e.preventDefault();
  });

  input.addEventListener("click", () => {
    if (input.hasAttribute("readonly")) {
      input.removeAttribute("readonly");
      clearBtn.textContent = "Check";
      msgBox.style.display = "none";
      msgIcon.innerHTML = "";
      msgText.textContent = "";
      msgBox.className = "pin-message";
    }
  });

  input.addEventListener("input", () => {
    input.value = input.value.replace(/\D/g, "");
  });

  // --- Auto-trigger if cookie exists ---
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  const savedPincode = getCookie("user_pincode");
  if (savedPincode && input) {
    input.value = savedPincode;
    input.setAttribute("readonly", "true");
    clearBtn.textContent = "Edit";
    if (expressNote) expressNote.style.display = "none";
    checkServiceability(savedPincode);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initPincodeChecker();

  const input = document.getElementById("deliveryFullInput");
  const clearBtn = document.getElementById("clearInputBtn");

  // ✅ Auto-trigger if pincode is prefilled by Liquid and no cookie yet
  if (input && input.value && input.value.trim().length === 6 && !document.cookie.includes("user_pincode=")) {
    input.setAttribute("readonly", "true");
    clearBtn.textContent = "Edit";
    checkServiceability(input.value.trim());
  }
});


document.addEventListener('DOMContentLoaded', () => {
    const sectionHeaders = document.querySelectorAll('.pdp-clps-header');
    const masterToggle = document.querySelector('.pdp-clps-title');
    const masterIcon = masterToggle.querySelector('.pdp-clps-toggle-icon');
    const allItems = document.querySelectorAll('.pdp-clps-item');

    // Open first accordion by default
    const firstItem = allItems[0];
    if (firstItem) {
        const firstContent = firstItem.querySelector('.pdp-clps-content');
        const firstIcon = firstItem.querySelector('.pdp-clps-toggle-icon');
        if (firstContent && firstIcon) {
            firstContent.classList.remove('pdp-clps-hidden'); // show content
            firstIcon.textContent = '–'; // update icon
        }
    }

    // Individual section toggle
    sectionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const content = header.nextElementSibling;
            const icon = header.querySelector('.pdp-clps-toggle-icon');
            const isOpen = !content.classList.contains('pdp-clps-hidden');

            content.classList.toggle('pdp-clps-hidden');
            icon.textContent = isOpen ? '+' : '–';
        });
    });

    // Master toggle
    let areItemsVisible = true;

    masterToggle.addEventListener('click', () => {
        areItemsVisible = !areItemsVisible;

        allItems.forEach(item => {
            item.style.display = areItemsVisible ? 'block' : 'none';
        });

        masterIcon.textContent = areItemsVisible ? '–' : '+';
    });
});



function styleOneSizeSwatchLabel() {
  document.querySelectorAll(".swatches__form--label").forEach(function (label) {
    if (label.textContent.trim().toLowerCase() === "one size") {
      label.style.setProperty("padding", "12px 0", "important");
      label.style.display = "inline-block";
      label.style.fontSize = "15px";
      label.style.whiteSpace = "normal"; // for cross-browser compatibility
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  styleOneSizeSwatchLabel();
});


document.addEventListener("DOMContentLoaded", function () {
  initTooltipToggle();
  initShareClickHandlers();
});

function initTooltipToggle() {
  const tooltip = document.querySelector(".pdp_info_tooltip");

  if (!tooltip) return;

  tooltip.addEventListener("click", function (e) {
    e.stopPropagation();
    closeAllShareMenus();
    tooltip.classList.toggle("active");
  });

  document.addEventListener("click", function (e) {
    if (!tooltip.contains(e.target)) {
      tooltip.classList.remove("active");
    }
  });
}

function toggleShare(button) {
  const shareMenu = button.nextElementSibling;
  const isActive = button.classList.contains('active');

  closeAllShareMenus();

  if (!isActive) {
    shareMenu.style.display = 'flex';
    button.classList.add('active');
  }
}

function closeAllShareMenus() {
  document.querySelectorAll('.product_social_icon_container').forEach(el => el.style.display = 'none');
  document.querySelectorAll('.share_button').forEach(btn => btn.classList.remove('active'));
}

function initShareClickHandlers() {
  document.addEventListener('click', function (event) {
    const shareContainer = event.target.closest('.product_social_media_container');
    const shareButton = event.target.closest('.share_button');
    const isInsideMenu = event.target.closest('.product_social_icon_container');

    if (shareButton) return;

    if (
      !shareContainer ||
      (isInsideMenu &&
        !event.target.closest('a') &&
        !event.target.closest('button') &&
        event.target.tagName !== 'IMG')
    ) {
      closeAllShareMenus();
    }
  });

  // Optional: if needed as backup to ensure menu closes when clicking elsewhere
  document.addEventListener('click', function (event) {
    const isClickInside = event.target.closest('.product_social_media_container');
    if (!isClickInside) {
      closeAllShareMenus();
    }
  });
}

function copyProductUrl(button, url) {
  navigator.clipboard.writeText(url).then(() => {
    const copyIcon = button.querySelector('.copy-icon');
    const copiedIcon = button.querySelector('.copied-icon');

    copyIcon.style.display = 'none';
    copiedIcon.style.display = 'inline-block';

    setTimeout(() => {
      copiedIcon.style.display = 'none';
      copyIcon.style.display = 'inline-block';
    }, 3000);
  });
}



document.addEventListener('DOMContentLoaded', function () {
    const viewAllModal = document.getElementById('mo-offerModal');
    const couponModal = document.getElementById('mo-couponModal');

    const viewAllBtn = document.getElementById('mo-offerToggle');
    const couponTrigger = document.getElementById('mo-couponTrigger');

    const closeViewAll = document.getElementById('mo-closeModal');
    const closeCoupon = document.getElementById('mo-closeCouponModal');

    if (viewAllBtn && viewAllModal) {
        viewAllBtn.addEventListener('click', function (e) {
            e.preventDefault();
            viewAllModal.classList.remove('mo-hidden');
        });
    }

    if (closeViewAll && viewAllModal) {
        closeViewAll.addEventListener('click', function () {
            viewAllModal.classList.add('mo-hidden');
        });
    }

    if (couponTrigger && couponModal) {
        couponTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            couponModal.classList.remove('mo-hidden');
        });
    }

    if (closeCoupon && couponModal) {
        closeCoupon.addEventListener('click', function () {
            couponModal.classList.add('mo-hidden');
        });
    }

    window.addEventListener('click', function (e) {
        if (e.target === viewAllModal) viewAllModal.classList.add('mo-hidden');
        if (e.target === couponModal) couponModal.classList.add('mo-hidden');
    });

    const copyIcons = document.querySelectorAll('.copy-icon, .mo-copy-icon');
    copyIcons.forEach((icon) => {
        icon.addEventListener('click', function () {
            const code = icon.dataset.code;
            if (!code) return;

            navigator.clipboard
                .writeText(code)
                .then(() => {
                    const clipboardIcon = icon.querySelector('.clipboard-icon, .mo-clipboard-icon');
                    const checkIcon = icon.querySelector('.check-icon, .mo-check-icon');

                    if (clipboardIcon && checkIcon) {
                        clipboardIcon.style.display = 'none';
                        checkIcon.style.display = 'inline';

                        setTimeout(() => {
                            checkIcon.style.display = 'none';
                            clipboardIcon.style.display = 'inline';
                        }, 120000);
                    }
                })
                .catch((err) => console.error('Copy failed:', err));
        });
    });
});



document.addEventListener('DOMContentLoaded', function() {
    var toggle = document.getElementById('offerToggle');
    var hiddenOffers = document.querySelectorAll('.hidden-offer');
    if (hiddenOffers.length > 0 && toggle) {
      toggle.style.display = 'inline-block';
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        hiddenOffers.forEach(function(el) {
          el.style.display = expanded ? 'none' : 'block';
        });
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        toggle.querySelector('.offer-text').textContent = expanded ? 'View All' : 'Hide';
      });
    }
  });

function initOfferToggle() {
  var toggle = document.getElementById('offerToggle');
  var hiddenOffers = document.querySelectorAll('.hidden-offer');

  if (hiddenOffers.length > 0 && toggle) {
    toggle.style.display = 'inline-block';

    // Remove any existing click listeners first
    toggle.replaceWith(toggle.cloneNode(true));
    toggle = document.getElementById('offerToggle'); // re-select since replaced

    toggle.addEventListener('click', function(e) {
      e.preventDefault();

      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      hiddenOffers.forEach(function(el) {
        el.style.display = expanded ? 'none' : 'block';
      });

      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      toggle.querySelector('.offer-text').textContent = expanded ? 'View All' : 'Hide';
    });
  }
}

function initCopyToClipboard() {
  // Select both normal and modal copy icons
  const copyIcons = document.querySelectorAll('.copy-icon, .mo-copy-icon');

  copyIcons.forEach(icon => {
    // Remove old event listeners by replacing the node
    icon.replaceWith(icon.cloneNode(true));
  });

  // Re-select fresh nodes
  const freshCopyIcons = document.querySelectorAll('.copy-icon, .mo-copy-icon');

  freshCopyIcons.forEach(icon => {
    icon.addEventListener('click', function () {
      const code = icon.dataset.code;
      if (!code) return;

      navigator.clipboard.writeText(code).then(() => {
        const clipboardIcon = icon.querySelector('.clipboard-icon, .mo-clipboard-icon');
        const checkIcon = icon.querySelector('.check-icon, .mo-check-icon');

        if (clipboardIcon && checkIcon) {
          clipboardIcon.style.display = 'none';
          checkIcon.style.display = 'inline';

          setTimeout(() => {
            checkIcon.style.display = 'none';
            clipboardIcon.style.display = 'inline';
          }, 1200);
        }
      }).catch(err => {
        console.error('Clipboard copy failed:', err);
      });
    });
  });
}


// Run once on page load
document.addEventListener('DOMContentLoaded', initOfferToggle);

/* --------------------------------------------------
   INSTANT COLOR SWITCH (ultra-fast reload)
-------------------------------------------------- */
document.addEventListener("click", (e) => {
  const swatch = e.target.closest(".swatch-product-color");
  if (!swatch) return;

  e.preventDefault();
  const productUrl = swatch.dataset.productUrl;
  if (!productUrl) return;



  // ⚡ Feels instant
  setTimeout(() => {
    window.location.href = `/products/${productUrl}`;
  }, 50);
});

/* --------------------------------------------------
   LOW STOCK ALERT — aligned + responsive
-------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (!window.lowStockConfig) {
    console.warn("Missing window.lowStockConfig");
    return;
  }

  const { threshold = 5, variants } = window.lowStockConfig;
  const sizeInputs = document.querySelectorAll(".swatches__form--input");

  // STEP 1: Create hidden alerts for all low-stock swatches
  sizeInputs.forEach((input) => {
    const variantId = input.dataset.variantId || input.value;
    const stock = variants[variantId] || 0;
    const swatch = input.closest(".swatch-element");

    if (!swatch) return;
    swatch.querySelector(".low-stock-inline")?.remove();

    if (stock === 0 || stock > threshold) return;

    // Wrap swatch content in a container to avoid layout shift
    const wrapper = swatch.querySelector(".swatch-inner") || document.createElement("div");
    if (!wrapper.classList.contains("swatch-inner")) {
      wrapper.classList.add("swatch-inner");
      while (swatch.firstChild) wrapper.appendChild(swatch.firstChild);
      swatch.appendChild(wrapper);
      swatch.style.position = "relative";
      wrapper.style.display = "flex";
      wrapper.style.flexDirection = "column";
      wrapper.style.alignItems = "center";
    }

    const alert = document.createElement("div");
    alert.className = "low-stock-inline";
    alert.textContent = `Only ${stock} left`;

    Object.assign(alert.style, {
      marginTop: "4px",
      color: "#d32f2f",
      fontFamily: "Helvetica, Arial, sans-serif",
      fontWeight: "400",
      fontStyle: "normal",
      fontSize: window.innerWidth < 768 ? "10px" : "12px",
      lineHeight: "14px",
      letterSpacing: "0",
      opacity: "0",
      transition: "opacity 0.2s ease",
      pointerEvents: "none",
      display: "none",
    });

    wrapper.appendChild(alert);
  });

  // STEP 2: Show alert only for selected swatch
  function updateAlertVisibility(selectedInput) {
    document.querySelectorAll(".low-stock-inline").forEach((alert) => {
      alert.style.display = "none";
      alert.style.opacity = "0";
    });

    const swatch = selectedInput.closest(".swatch-element");
    const alert = swatch?.querySelector(".low-stock-inline");
    if (alert) {
      alert.style.display = "block";
      requestAnimationFrame(() => (alert.style.opacity = "1"));
    }
  }

  // Initial state
  const initial = document.querySelector(".swatches__form--input:checked");
  if (initial) updateAlertVisibility(initial);

  // On size change
  document.addEventListener("change", (e) => {
    if (e.target.matches(".swatches__form--input")) {
      updateAlertVisibility(e.target);
    }
  });

  // STEP 3: Responsive font on resize
  window.addEventListener("resize", () => {
    document.querySelectorAll(".low-stock-inline").forEach((alert) => {
      alert.style.fontSize = window.innerWidth < 768 ? "10px" : "12px";
    });
  });
});

